module.exports = __webpack_public_path__ + "img/police_academy.94df9b8c.jpg";